(() => {
  if (window.natureliaFlowUIInitialized) return;
  window.natureliaFlowUIInitialized = true;
  document.addEventListener('click', (event) => {
    const searchContainer = event.target.closest('#SearchContainer');
    const searchSubmit = event.target.closest('#SearchContainer .input-group-btn button, #search-show-more a, .search-results__meta-view-all a');
    if (searchContainer && searchSubmit) {
      const input = searchContainer.querySelector('#search-input');
      if (input) {
        event.preventDefault();
        event.stopImmediatePropagation();
        const url = new URL((window.Shopify?.routes?.root || '/') + 'search', location.origin);
        url.searchParams.set('q', input.value.trim());
        url.searchParams.set('type', 'product,article,page');
        location.assign(url.href);
        return;
      }
    }
    const link = event.target.closest('a[data-naturelia-navigation]');
    const drawer = link?.closest('#NavDrawer');
    if (!drawer) return;
    const url = new URL(link.href, location.href);
    if (url.pathname !== location.pathname || !url.hash) return;
    const target = document.getElementById(url.hash.slice(1));
    const close = drawer.querySelector('.mobile-menu--close-btn');
    if (!target || !close) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    close.click();
    const started = performance.now();
    const settle = () => {
      if (drawer.getBoundingClientRect().right > 1 && performance.now() - started < 2200) {
        requestAnimationFrame(settle);
        return;
      }
      history.replaceState(null, '', url.hash);
      target.scrollIntoView({behavior: 'auto', block: 'start'});
      const heading = target.querySelector('h2');
      if (heading) { heading.tabIndex = -1; heading.focus({preventScroll: true}); }
    };
    requestAnimationFrame(settle);
  }, true);

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Enter' || event.target.id !== 'search-input') return;
    event.preventDefault();
    event.stopImmediatePropagation();
    const url = new URL((window.Shopify?.routes?.root || '/') + 'search', location.origin);
    url.searchParams.set('q', event.target.value.trim());
    url.searchParams.set('type', 'product,article,page');
    location.assign(url.href);
  }, true);

  const initializeSticky = () => {
    if (!document.body.classList.contains('template-product')) return;
    const original = document.querySelector('#AddToCartForm #AddToCart');
    if (!original || document.querySelector('.naturelia-flow-sticky')) return;
    const panel = document.createElement('div');
    panel.className = 'naturelia-flow-sticky';
    panel.dataset.visible = 'false';
    const button = document.createElement('button');
    button.type = 'button';
    panel.append(button);
    document.body.append(panel);
    button.textContent = document.documentElement.dataset.natureliaProductOptions || 'Choose quantity & add to cart';
    button.addEventListener('click', () => {
      const form = document.getElementById('AddToCartForm');
      if (!form) return;
      const add = form.querySelector('#AddToCart');
      const target = add && !add.disabled ? add : [...form.querySelectorAll('input:not([type="hidden"]), select, button, [tabindex]')]
        .find(control => !control.disabled && control.getClientRects().length > 0);
      form.scrollIntoView({behavior: 'auto', block: 'center'});
      if (target) target.focus({preventScroll: true});
      panel.dataset.visible = 'false';
    });
    let observedButton = null;
    const visibility = new IntersectionObserver(([entry]) => {
      panel.dataset.visible = String(!entry.isIntersecting);
    }, {threshold: 0});
    const bindCurrentButton = () => {
      const current = document.querySelector('#AddToCartForm #AddToCart');
      if (current === observedButton) return;
      if (observedButton) visibility.unobserve(observedButton);
      observedButton = current;
      if (current) visibility.observe(current);
    };
    bindCurrentButton();
    new MutationObserver(bindCurrentButton).observe(document.querySelector('.product-section') || document.body, {childList: true, subtree: true});
  };
  initializeSticky();
  document.addEventListener('shopify:section:load', initializeSticky);
})();
